import React, { Component } from "react";
import { connect } from "react-redux";
import { 
  setHomeValue,
  increaseStepByOne
} from "../../../actions";
import { options } from "../../../operations";
import { Body } from '../../Common/Form';
import Text from '../../Common/Form/Text';
import SelectedAnswers from './SelectedAnswers';
import Loader from '../../Common/Loader';
import { 
  numberWithDots,
  compareValues
} from "../../../helpers";

import homedownIcon from '../../../assets/icons/hogar/ic_homedown.png';

class HogarForm_3 extends Component {

  constructor(props) {
    super(props);
    this.getContent = this.getContent.bind(this);
  }

  componentDidMount () {
    const { 
      cleanOptionsSelected
    } = this.props;
    cleanOptionsSelected();
  }

  getContent() {

    const {
      isLoading,
      fireOptions,
      onOptionSelect,
      getFireOptions,
    } = this.props;

    return (
      <div>
        <SelectedAnswers />
        <div className="SkyBlue-box">
          <p className="SkyBlue-text SkyBlue-text-bold"> Bien, comencemos por definir CÓMO vamos a PROTEGER tu HOGAR </p>
          <p className="SkyBlue-text"> Este seguro te permite proteger la estructura de tu casa y las cosas que hay en su interior. </p>
          <span className="SkyBlue-text SkyBlue-text-title"> Comencemos por la ESTRUCTURA. </span>
        </div>
        <div className="OptionInfo-container">
          <img className="OptionInfo-icon" src={homedownIcon} alt="info" />
          <div className="OptionInfo-text">
            Para cubrir la estructura de tu HOGAR en caso de Incendio, definamos cuál sería el valor en caso de tener que construirlo nuevamente.
          </div>
        </div>
        { isLoading ? <Loader message='' /> : (
          (fireOptions && fireOptions.length > 0 &&
            <div className="OptionInfo-options-container">
              {fireOptions.sort(compareValues('Value', 'desc')).map((fire) => {
                const amountText = 'U$S ' + numberWithDots(fire.Value);
                return (
                  <div
                    key={fire.Code}
                    className="OptionInfo-options-option"
                    onClick={() => { onOptionSelect(fire) }}>
                    {amountText}
                  </div>
                );
              })}
            </div>
          ) || 
          ((!fireOptions || !fireOptions.length) &&
            <>
              <div className="OptionInfo-text OptionInfo-center"> Las opciones no cargaron correctamente. </div>
              <div
                style={{'display': 'inline-flex'}}
                className="OptionInfo-options-option"
                onClick={getFireOptions}>
                Volver a cargar
              </div>
            </>
          )
        )}
      </div>
    );
  }

  render() {
    return (
      <div>
        <Body columnContent={this.getContent} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    fireOptions: state.home.fireOptions,
    isLoading: state.steps.isInnerLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onOptionSelect: (fire) => {
      dispatch(setHomeValue('fireSelected', fire));
      dispatch(increaseStepByOne());
    },
    cleanOptionsSelected: () => {
      dispatch(setHomeValue('fireSelected', null));
      dispatch(setHomeValue('theftSelected', null));
    },
    getFireOptions: () => {
      dispatch(options.getFireOptions());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HogarForm_3);